import { useState, useEffect } from 'react';
import { ButtonLoading, Icons } from 'components';
import { Menu, MenuItem, IconButton, Grid } from '@mui/material';
import { useStyles } from './style';
import { CircularProgress } from '@mui/material';
import Collapse from '@mui/material/Collapse';
const TableItemActionsNew = ({ otherMenus = [], startIcon, title, iconButton = false, disabled }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [id, setId] = useState(null);
  // --HOOKS--//
  const classes = useStyles();
  useEffect(() => {
    //onCheckAndRemoveItemsObject()
  }, []);


  const handleClick = (event) => {
    if (event.currentTarget) {
    }
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    otherMenus.map((v, k) => {
      if (v && v.children) {
        v.isOpen = false;
      }
    });
    setId(null);
    setAnchorEl(null);
  };
  const onCheckAndRemoveItemsObject = () => {
    let copy = JSON.parse(JSON.stringify(otherMenus))
    let copyArray2 = [];
    for (let i = 0; i < copy.length; i++) {
      const element = copy[i];
      if (element.isShow === true) {
        //copy.splice(i, 1);
        copyArray2.push(element);
      }

    }
    let array2 = []
    for (let i = 0; i < copyArray2.length; i++) {
      const element = copyArray2[i];
      if (element.children && element.children.length > 0 && element.isShow === true) {
        for (let j = 0; j < element.children.length; j++) {
          const element2 = element.children[j];
          if (element2.isShow === true) {
            element2['parent'] = i;
            array2.push(element2)
          }

        }
      }
    }
    let map = copyArray2.map((a) => {
      a.children && (a.children = []);
    })
  }

  const checkArranyIsShowIndex = (array = []) => {
    for (let i = 0; i < array.length; i++) {
      const element = array[i];
      if (element.isShow === false) {
        array.splice(i, 1);
      }
      if (element.children && element.children.length > 0 && element.isShow !== false) {
        checkArranyIsShowIndex(element.children)
      }

    }
  }




  // --API--//

  return (
    <div className={classes.otherActions} >
      {iconButton ? (
        <div onClick={handleClick} className={classes.operation}>
          {disabled ? (<CircularProgress size={24} className={classes.buttonProgress} />) : (<IconButton disabled={disabled} size="large">
            <Icons icon="MoreHorizontal" color="#303d8f" size="25" />
          </IconButton>)}
          {title !== "" && (
            <span >{title}</span>
          )}

        </div>
      ) : (
        <ButtonLoading
          variant="outlined"
          onClick={handleClick}
          color="primary"
          startIcon={startIcon ?? null}
          name={title ?? 'عملیات'}
          aria-controls="simple-menu"
          aria-haspopup="true"
        />
      )}

      <Menu
        id="simple-menu"
        className={classes.otherActionsMenu}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => handleClose()}
      >
        {otherMenus.map((v, k) =>
          !v?.children && (v.isShow || v.isShow === undefined) ? (
            <MenuItem
              className={classes.otherActionsMenuItem}
              key={k}
              disabled={v?.disabled}
              onClick={() => {
                if (v?.disabled) return;
                v?.onClick?.();
                handleClose();
              }}
            >
              {v?.title}
            </MenuItem>
          ) : (
            (v.isShow || v.isShow === undefined) && <MenuItem
              className={classes.otherActionsMenuItem}
              key={k}
              disabled={v?.disabled}
              onClick={() => {
                if (v?.disabled) return;
                if (id) {
                  otherMenus.map((s, k) => {
                    if (s && s.children && v.id !== id) {
                      s.isOpen = false;
                    }
                  });
                }
                v.isOpen = !v.isOpen;
                setId(v.id);
              }}
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              <Grid
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%',
                  height: '100%',
                }}
              >
                <span>{v?.title}</span>
                <span>{v.isOpen ? <Icons icon="CaretUp" color="#404040" size="20" /> : <Icons icon="CaretDown" color="#404040" size="20" />}</span>
              </Grid>
              <Grid>
                <Collapse key={k} component="li" in={v.isOpen} timeout="auto" unmountOnExit>
                  {v?.children.map((v2, k2) => (
                    (v2?.isShow === true || v2?.isShow === undefined) && <MenuItem
                      className={classes.otherActionsMenuItem}
                      key={k2}
                      disabled={v2?.disabled}
                      onClick={() => {
                        if (v2?.disabled) return;
                        v2?.onClick?.();
                        v2.otherLocation === undefined
                          ? handleClose()
                          : v2.otherLocation
                            ? handleClose()
                            : console.log('nothing');
                      }}
                    >
                      {v2?.title}
                    </MenuItem>
                  ))}
                </Collapse>
              </Grid>
            </MenuItem>
          ),
        )}
      </Menu>
    </div>
  );
};

export default TableItemActionsNew;
